<template>
  <div class="account">
    <div class="row">
      <div class=" col-lg-12">
        <aside class="widget card widget--sidebar widget-standings">
          <header class="card__header card__header--shop-filter">
            <div class="shop-filter">
              <h4 class="shop-filter__result" style="text-align: left; font-size: 16px;">
                Quản lý tài khoản TQC Tần Tử Anh
              </h4>
            </div>
          </header>
          <div class="widget__content card__content">
            <br />
            <div class="row">
              <div class="col-md-3">
                <Menu/>
              </div>
              <div class="col-md-9" id="reset_content">
                <div>Bạn có thể gửi yêu cầu xóa Mã Bảo Vệ và Mã Giao Dịch cho tài khoản <b>{{ user.account }}</b></div>
                <div>Hãy cẩn thận với hành động này của bạn !</div>
                <br/>
                <br/>
                <div>Mã bảo vệ:
                    <b  v-bind:class="[user.sec_pwd ? 'text-green' : 'text-red']">{{ user.sec_pwd ? 'Đã thiết lập' : 'Chưa thiết lập' }}</b></div>
                <div>Mã giao dịch:
                    <b  v-bind:class="[user.trade_psw ? 'text-green' : 'text-red']">{{ user.trade_psw ? 'Đã thiết lập' : 'Chưa thiết lập' }}</b></div>
                <br/><br/>
                <div class="frm_reset" v-if="user.sec_pwd || user.trade_psw">
                  <div>
                      <div class="text-left"><label for="email">Email</label></div>
                      <div><input type="email" maxlength="55" v-model="email" placeholder="Nhập địa chỉ Email"
                          class="form-control" id="email"></div>
                    </div>
                    <div>
                      <div class="text-left"><label for="password">Mật khẩu</label></div>
                      <div><input type="password" maxlength="15" v-model="password" placeholder="Mật khẩu"
                          class="form-control" id="password"></div>
                    </div>
                    <br>
                  <button class="btn btn-danger btn-sm" v-on:click="resetPassowrd()">Xóa Mã Bảo Vệ và Mã Giao Dịch</button>
                </div>
                <div v-if="!user.sec_pwd && !user.trade_psw">
                  Hãy cài đặt Mã Bảo Vệ và Mã Giao Dịch cho tài khoản <b>{{ user.account }}</b> luôn và ngay !
                </div>
              </div>
            </div>
            <br />
          </div>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Vue from 'vue'
  import Menu from './Menu'

  export default {
    name: 'ResetPassword',
    components: {
      Menu
    },
    props: {
      tqc_api: '',
      token: '',
      user: {}
    },
    mounted() {
      this.$emit('get-info')
    },
    methods: {
      resetPassowrd() {
        if (this.clicked) {
          return false
        }
        if (!this.validate()) {
          return false
        }
        this.clicked = true

        if (confirm('Bạn chắc chắn muốn xóa mã giao dịch và mã bảo vệ ?')) {
          axios.put(`${this.tqc_api}reset-password`, {
            token: this.token,
            email: this.email,
            password: this.password,
          }).then(({data}) => {
            this.clicked = false
            localStorage.user = null
            this.$emit('get-info')
            alert('Xóa Mã Bảo Vệ và Mã Giao Dịch thành công !')
          }).catch(error => {
            this.clicked = false
            alert('Thông tin không chính xác !')
          })
        }
      },      
      validate() {
        if (this.email.length < 6) {
          alert('Email không được để trống !')
          return false
        }
        if (this.password.length < 6) {
          alert('Mật khẩu không được để trống !')
          return false
        }

        return true
      }
    },
    data() {
      return {        
        email: '',
        password: '',
        clicked: false
      }
    }
  }
</script>

<style scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  #reset_content {
    color: white;
    font-size: 16px;
  }
  .text-red {
    color: red;
  }
  .text-green {
    color: #2be428;
  }
  input {
    height: 35px;
    margin-bottom: 8px;
  }
  .frm_reset {
    width: 50%;
    margin: auto;
  }
</style>